module.exports = __webpack_public_path__ + "assets/images/dashboards.png";


//////////////////
// WEBPACK FOOTER
// ./app/components/dashboard/dashboards.png
// module id = /Mo1
// module chunks = 1